var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DemoBase',{attrs:{"size":"xs5"}},[_c('FormHeader',{staticClass:"pa-10 text-center",attrs:{"title":"Example","description":"Description"}}),_c('v-divider'),_c('FormHeader',{staticClass:"pa-10 text-center",attrs:{"icon":"platform/qrcode.png","title":"With Icon","description":"Description"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }